<template>
  <div>
    <b-alert v-show="alert.alertShow" show dismissible :variant="alert.alertVariant">{{ alert.alertMsg }}</b-alert>
    <b-tabs content-class="p-3 text-muted">
      <b-tab active>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-user-cog"></i>
          </span>
          <span class="d-none d-sm-inline-block"> Σταθερό Πρόγραμμα</span>
        </template>
        <div class="row">
          <h3 class="card-title" style="text-decoration:underline;">
            Ωράριο Εργασίας
          </h3>
          <div class="col-md-5">
            <div class="mb-3">
              <label class="mt-3">Από*</label>
              <b-form-input id="example-input" v-model="startDate" type="date" placeholder="DD-MM-YYYY"
                format="DD-MM-YYYY" autocomplete="off"></b-form-input>
            </div>
          </div>
          <div class="col-md-5">
            <div class="mb-3">
              <label class="mt-3">Μέχρι*</label>
              <b-form-input id="example-input" v-model="endDate" type="date" placeholder="YYYY-MM-DD"
                autocomplete="off"></b-form-input>
            </div>
          </div>
          <div class="col-md-8">
            <div class="mt-3">
              <label>Ημέρες</label>

              <multiselect required v-model="weekdaySelected" :options="weekdayOptions" track-by="id" label="weekday"
                multiple placeholder="Επιλέξτε Ημέρες" selectLabel="Eπιλογή Ημέρα" selectedLabel="Επιλέχθηκε"
                deselectLabel="Αποεπιλογή">
              </multiselect>
            </div>
          </div>

          <div v-for="(applicant, idx) in workingSchedule" :key="idx" class="row">
            <div class="col-md-4">
              <div class="mt-3">
                <label>Ώρα Έναρξης</label>
                <br />
                <date-picker v-model="workingSchedule[idx].start_time" format="HH:mm" value-type="format" type="time"
                  placeholder="hh:mm"></date-picker>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mt-3">
                <label>Ώρα Λήξης</label>
                <br />
                <date-picker v-model="workingSchedule[idx].end_time" format="HH:mm" value-type="format" type="time"
                  placeholder="hh:mm"></date-picker>
              </div>
            </div>
            <div class="col-md-4">
              <div class="mt-3">
                <label>Νυχτερινό ωράριο</label>
                <b-form-checkbox v-model="workingSchedule[idx].is_night_shift" class="mb-3 custom-checkbox"
                  plain></b-form-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6">
                <div class="col-sm-5">
                  <button v-show="idx == workingSchedule.length - 1 &&
                    workingSchedule.length < 2
                    " class="btn btn-primary" @click.prevent="addFormField(idx)">
                    <i class="bx bx-calendar-event ">Προσθήκη βάρδιας</i>
                  </button>
                  <button v-show="idx || (!idx && workingSchedule.length > 1)" class="btn btn-danger"
                    @click.prevent="removeFormField(idx)">
                    <i class="bx bx-calendar-event ">Αφαίρεση βάρδιας</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12" style="display:flex;justify-content:center;">
              <b-form-checkbox v-model="checked" class="mb-3" plain>Προσθήκη Νέου Προγράμματος*</b-form-checkbox>
            </div>

            <p>
              *Με την προσθήκη νέου Προγράμματος αποθηκεύεται καινούριο ωράριο
              για μελλοντικούς σκοπούς
            </p>

            <p>
              Για την προσθήκη νέου Προγράμματος εργασίας θα πρέπει η Ημερομηνία
              <strong>Έναρξης του καινούριου προγράμματος</strong> να είναι
              <u>τουλάχιστον</u> μια μέρα μετά την ημερομηνία
              <strong>λήξης του παλιού προγράμματος</strong>
            </p>
          </div>

          <div class="col-md-4">
            <button v-if="!errorMsgs" class="btn btn-primary" @click.prevent="scheduleUpdateOrCreate">
              Ενημέρωση
            </button>
          </div>
        </div>
      </b-tab>
      <b-tab v-if="iamthesuper">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-user-cog"></i>
          </span>
          <span class="d-none d-sm-inline-block">Καταχωρημένο Πρόγραμμα</span>
        </template>

        <PersonWorkingSchedule :personWorkingScheduleData="personWorkingScheduleData"
          :currentSchedulePage="currentSchedulePage" @handleDeleteEmit="emitDeleteSchedule">
        </PersonWorkingSchedule>
        <button class="btn btn-primary" @click.prevent=handleNextPage() v-if="hasNextPage">Παλιότερα</button>

      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import moment from "moment";
import session from "../../../../api/session";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import { weekDays } from "../utils";
import Swal from "sweetalert2";
import { eventCreate } from "../../../../eventspy.js";
import PersonWorkingSchedule from "./oldScheduleUserTab.vue";
export default {
  components: {
    Multiselect,
    DatePicker,
    PersonWorkingSchedule,
  },
  data() {
    return {
      iamthesuper: true,
      personWorkingScheduleData: [],
      workingSchedule: [
        {
          id: null,
          start_time: null,
          end_time: null,
          start_date: null,
          end_date: null,
          is_night_shift: false,
        },
      ],
      startDate: "",
      endDate: "",
      personWorkingSchedule: [],
      weekdaySelected: [],
      checked: false,
      errorMsgs: "",
      alert: {
        alertShow: false,
        alertMsg: "",
        alertVariant: "success",
      },
      currentSchedulePage: 1,
      totalPages: 0,
      hasNextPage: true
    };
  },
  mounted() {
    this.fetchUserDetails();
    this.fetchPersonWorkingSchedule();
  },
  computed: {
    weekdayOptions() {
      return weekDays;
    },
  },
  methods: {
    emitDeleteSchedule() {
      this.$nextTick(() => {
        this.fetchPersonWorkingSchedule()
      })
    },
    async handleNextPage() {
      this.currentSchedulePage++;
      await session.get(`api/${this.$route.params.id}/schedule/?page=${this.currentSchedulePage}`).then((resp) => {
        this.personWorkingScheduleData = this.personWorkingScheduleData.concat(resp.data.results);
        this.totalPages = resp.data.total_pages
        this.hasNextPage = resp.data.links.next != null ? true : false
      })
        .catch((e) => {
          console.log(e);
          this.handleError(e);
        });
    },
    handleError(error) {
      setTimeout(() => {
        this.alertMsg = JSON.stringify(error.response.data);
        this.alertShow = true;
        this.alertVariant = "danger";
      }, 5000);
      this.alertShow = false;
    },

    async fetchPersonWorkingSchedule() {

      await session
        .get(`api/${this.$route.params.id}/schedule/`)
        .then((resp) => {

          this.personWorkingScheduleData = resp.data.results;
          this.totalPages = resp.data.total_pages
          this.hasNextPage = resp.data.links.next != null ? true : false
        })
        .catch((e) => {
          console.log(e);
          setTimeout(() => {
            this.alertMsg = JSON.stringify(e.response.data);
            this.alertShow = true;
            this.alertVariant = "danger";
          }, 5000);
          this.alertShow = false;
        });
    },
    async fetchUserDetails() {
      await session
        .get(`api/user/${this.$route.params.id}/`)
        .then((resp) => {
          if (resp.data.schedule.length > 0) {
            this.personWorkingSchedule = resp.data.schedule;

            this.weekdaySelected = resp.data.schedule.map((e) =>
              e.weekdays.length > 0
                ? e.weekdays.map((e) => {
                  return {
                    id: e.weekday,
                    weekday_id: e.id,
                    weekday: e.weekday_name,
                  };
                })
                : ""
            )[0];

            this.workingSchedule = resp.data.schedule.map((e) => {
              return {
                id: e.id,
                start_time: e.start_time,
                end_time: e.end_time,
                start_date: e.start_date,
                end_date: e.end_date,
                is_night_shift: e.is_night_shift,
              };
            });
            this.startDate = resp.data.schedule.map((e) => e.start_date)[0];
            this.endDate = resp.data.schedule.map((e) => e.end_date)[0];
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async fetchPersonSchedule() {
      await session
        .get(`api/user/schedule/${this.$route.params.id}/update/`)
        .then((resp) => {
          this.personWorkingSchedule = resp.data;
        });
    },
    addFormField() {
      this.workingSchedule.push({
        start_time: null,
        end_time: null,
        start_date: this.startDate,
        end_date: this.endDate,
      });
    },
    removeFormField(idx) {
      const deleteSecondScheduleTime = this.workingSchedule[idx];
      if (deleteSecondScheduleTime.id) {
        this.confirm(deleteSecondScheduleTime.id, idx);
      } else {
        this.workingSchedule.splice(idx, 1);
      }
    },
    confirm(scheduleID, idx) {
      Swal.fire({
        title: "Είστε σίγουρος;",
        text: "Δεν θα μπορείτε να το επαναφέρετε!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι, διαγράψτε το!",
      }).then((result) => {
        if (result.value) {
          session
            .delete(`api/user/schedule/${scheduleID}/delete/`)
            .then(() => {
              Swal.fire("Διαγράφηκε!", "Το ωράριο έχει διαγραφεί.", "success");
              this.workingSchedule.splice(idx, 1);
              this.fetchUserDetails();
            })
            .catch((e) => {
              this.$toastr.e(Object.values(e.response.data));
            });
        }
      });
    },

    isValidShifts() {
      if (this.workingSchedule.length > 1) {
        for (var el = 0; el < this.workingSchedule.length - 1; el++) {
          if (
            moment(this.workingSchedule[el].end_time, "HH:mm").format(
              "HH:mm"
            ) >=
            moment(this.workingSchedule[el + 1].start_time, "HH:mm").format(
              "HH:mm"
            )
          ) {
            return false;
          } else {
            return true;
          }
        }
      }
      return true;
    },
    scheduleUpdateOrCreate() {
      if (this.checked) {
        const isValidFutureProgram = this.personWorkingSchedule.map(
          (e) =>
            // exei bug otan bazeis tis idies imerominies
            moment(this.startDate, "yyyy/MM/DD").format("yyyy/MM/DD") >
            moment(e.end_date, "yyyy/MM/DD").format("yyyy/MM/DD") &&
            moment(this.endDate, "yyyy/MM/DD").format("yyyy/MM/DD") >=
            moment(this.startDate, "yyyy/MM/DD").format("yyyy/MM/DD")
        )[0];
        if (!isValidFutureProgram) {
          this.alert.alertShow = true;
          this.alert.alertVariant = "danger";
          this.alert.alertMsg =
            "Για την προσθήκη νέου Προγράμματος εργασίας θα πρέπει η Ημερομηνία Έναρξης να είναι τουλάχιστον μια μέρα μετά την ημερομηνία λήξης";
          setTimeout(() => {
            this.alert.alertShow = false;
          }, 4000);
          return;
        }
      }

      if (!this.isValidShifts()) {
        this.alert.alertShow = true;
        this.alert.alertMsg =
          "Η ώρα έναρξης της δεύτερης βάρδιας θα πρέπει να είναι μεγαλύτερη απο την ώρα λήξης της πρώτης βάρδιας";
        this.alert.alertVariant = "danger";
        setTimeout(() => {
          this.alert.alertShow = false;
        }, 3500);

        return;
      }

      this.workingSchedule.forEach((element) => {
        if (element.id && !this.checked) {
          const data = {
            person: this.$route.params.id,
            start_date: this.startDate,
            end_date: this.endDate,
            start_time: element.start_time,
            end_time: element.end_time,
            is_night_shift: element.is_night_shift,
            weekdays: this.weekdaySelected.map((e) => {
              return { id: e.weekday_id, weekday: e.id };
            }),
          };
          this.updateSchedule(element.id, data);
        } else {
          const newScheduleData = {
            person: this.$route.params.id,
            start_date: this.startDate,
            end_date: this.endDate,
            start_time: element.start_time,
            end_time: element.end_time,
            weekdays: this.weekdaySelected.map((e) => e.id + 1),
            is_night_shift: element.is_night_shift,
          };
          this.createSchedule(newScheduleData);
        }
      });

    },
    async updateSchedule(scheduleID, data) {
      await session
        .put(`api/user/schedule/${scheduleID}/update/`, data)
        .then(() => {
          this.$toastr.Add({
            name: "UniqueToastName",
            title: `Ενημέρωση`,
            msg: "Τα Ωράριο Εργασίας ανανεώθηκε επιτυχώς!",
            style: { backgroundColor: "#4fd69c", width: "550px" },
            progressbar: false,
            timeout: 3500,
          });

          eventCreate(
            `Επεξεργασια Προγραμματος
            ${JSON.stringify(this.personWorkingSchedule)}
            -----------------------------------------------------

            ${JSON.stringify(data)}`,
            2
          );
          this.fetchUserDetails();
          this.fetchPersonWorkingSchedule()
          //     this.$nextTick(() => {
          //   this.personWorkingScheduleData = []
          //   this.fetchPersonWorkingSchedule()
          // });

        })
        .catch((e) => {
          this.$toastr.e(Object.values(e.response.data));
        });
    },
    async createSchedule(data) {
      console.log(data);
      await session
        .post("api/user/schedule/create/", data)
        .then(() => {
          this.$toastr.Add({
            name: "UniqueToastName",
            title: `Ενημέρωση`,
            msg: "Τα Ωράριο Εργασίας προστέθηκε επιτυχώς!",
            style: { backgroundColor: "#4fd69c", width: "550px" },
            progressbar: false,
            timeout: 3500,
          });
          eventCreate(
            `Προσθήκη Προγραμματος
               ${JSON.stringify(data)}`,
            1
          );
          this.fetchUserDetails();
          this.fetchPersonWorkingSchedule()
        })
        .catch((e) => {
          this.$toastr.e(Object.values(e.response.data));
        });
    },
  },
};
</script>

<style scoped>
::v-deep .custom-checkbox .form-check-input {
  width: 30px;
  height: 30px;
}
</style>
